module.exports = __webpack_public_path__ + "img/a6.60c8f6a8.png";